import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HeartStraightIcon as HeartStraight, FlameIcon as Flame, ClockIcon as Clock } from "@phosphor-icons/react";
import { formatDate } from "@/lib/utils-app";

export default function BreedingPanel({ dog, listing, onList, onDelist, isOwner = true }) {
  const active = Boolean(listing);
  // Non-owners only ever see a read-only view of an active listing —
  // never the list/delist controls.
  if (!isOwner && !active) return null;
  return (
    <div
      className="bg-white border border-[#E5E5E5] rounded-xl p-6 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
      data-testid="breeding-panel"
    >
      <div className="flex items-center gap-2 mb-3">
        <HeartStraight size={20} weight="duotone" className="text-crimson" />
        <h3 className="font-spectral text-xl">Breeding directory</h3>
        {active && (
          <span className="text-[10px] font-bold uppercase tracking-[0.15em] bg-[#C1272D] text-white rounded-full px-2.5 py-1 ml-1">
            Live
          </span>
        )}
      </div>
      {active ? (
        <>
          <p className="text-sm text-[#6B6B6B]">
            <span className="inline-flex items-center gap-1">
              <Clock size={12} /> {listing.days}-day term
            </span>
            {" · expires "}
            <span className="text-ink font-semibold">{formatDate(listing.expires_at)}</span>
          </p>
          {listing.description && (
            <p className="text-sm mt-3 text-ink leading-relaxed">{listing.description}</p>
          )}
          <div className="flex flex-wrap gap-2 mt-5">
            {isOwner ? (
              <>
                <Link to="/breeding/my">
                  <Button variant="outline" size="sm" className="rounded-full border-[#E5E5E5]">
                    Manage listings
                  </Button>
                </Link>
                <Button
                  onClick={onDelist}
                  variant="outline"
                  size="sm"
                  className="rounded-full border-[#C1272D]/30 text-crimson hover:bg-[#C1272D]/5"
                  data-testid="delist-dog-btn"
                >
                  Remove listing
                </Button>
              </>
            ) : (
              <Link to={`/breeding/${listing.id}`}>
                <Button variant="outline" size="sm" className="rounded-full border-[#E5E5E5]" data-testid="view-breeding-listing-btn">
                  View in breeding directory
                </Button>
              </Link>
            )}
          </div>
        </>
      ) : (
        <>
          <p className="text-sm text-[#6B6B6B]">
            Make {dog.name} discoverable to other registrants looking for{" "}
            {dog.sex === "male" ? "a stud" : "a dam"}. Messaging stays in-app — your email stays
            private.
          </p>
          <Button
            onClick={onList}
            className="mt-5 rounded-full bg-[#0E0E0E] hover:bg-[#C1272D] text-white"
            data-testid="list-for-breeding-btn"
          >
            <HeartStraight size={14} className="mr-1" /> List for breeding
          </Button>
          {dog.sex === "female" && !(dog.heat_cycles?.length) && (
            <p className="text-xs text-[#6B6B6B] mt-3 flex items-center gap-1">
              <Flame size={12} weight="duotone" className="text-crimson" />
              Tip: add an expected heat cycle below before listing — helps matchmakers time things.
            </p>
          )}
        </>
      )}
    </div>
  );
}
